<template>
  <label
    class="group flex w-full flex-col"
    :class="[disabled ? 'pointer-events-none opacity-50' : 'cursor-pointer']"
    :for="uniqueId"
  >
    <div
      class="relative flex w-full items-center justify-between text-sm font-medium"
    >
      <span v-if="label || slots.label" class="ml-2">
        <slot name="label">{{ label }}</slot>
      </span>
      <input
        :id="uniqueId"
        v-model="selected"
        :disabled="disabled"
        v-bind="{ value, name }"
        type="radio"
        class="absolute right-0 top-0 z-0 opacity-0"
      />
      <div class="flex items-center gap-2">
        <span class="text-md font-semibold">
          <slot name="price"></slot>
        </span>
        <div
          class="z-10 inline-flex size-6 items-center justify-center rounded-full border border-neutral-30 bg-shade-200"
        >
          <span
            :class="[isActive ? 'size-4' : 'size-0']"
            class="inline-block rounded-full bg-black transition-all duration-300"
          />
        </div>
      </div>
    </div>
    <slot name="description"></slot>
  </label>
</template>

<script setup lang="ts" generic="Item extends { label: string; value: any }">
type Props = {
  modelValue?: string | number
  value?: Item['value']
  label?: Item['label']
  name?: string
  disabled?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  value: undefined,
  label: undefined,
  name: '',
  disabled: false,
})

const emit = defineEmits(['update:model-value'])
const slots = useSlots()

const selected = computed({
  get: () => props.modelValue,
  set: (value?: string | number) => emit('update:model-value', value),
})

const isActive = computed(() => props.modelValue === props.value)
const uniqueId = useId()
</script>
